// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__HCavk","container":"Modal_container__lbinq","header":"Modal_header__qz7bC","body":"Modal_body__CoVQc"};